// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__6g-Zf","input":"Input_input__+rBLR","label":"Input_label__jyQOg","error":"Input_error__w79Is","col2":"Input_col2__p1mPz"};